import script from "./header.vue?vue&type=script&setup=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=42f42055&lang=css"
import "./header.vue?vue&type=style&index=1&id=42f42055&scoped=true&lang=css"

import exportComponent from "D:\\Downloads\\resee-web-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42f42055"]])

export default __exports__